<svg viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1727 2.12258H11.299V0.5L0 2.24668V17.5523L11.299 19.5006V17.0975H18.1727C18.6294 17.0975 19 16.7643 19 16.3529V2.86717C19 2.45578 18.6294 2.12258 18.1727 2.12258ZM18.2811 16.4764H11.2761L11.2649 15.1926H12.9517V13.6978H11.2513L11.2432 12.8142H12.9517V11.3195H11.2302L11.2221 10.4359H12.9517V8.94113H11.2166V8.05756H12.9517V6.56218H11.2166V5.6786H12.9517V4.18384H11.2166V2.82559H18.2811V16.4764Z"
      fill="#219653"
    />
    <path d="M16.8349 4.18384H13.9019V5.6786H16.8349V4.18384Z" fill="#219653" />
    <path d="M16.8349 6.56219H13.9019V8.05695H16.8349V6.56219Z" fill="#219653" />
    <path d="M16.8349 8.94113H13.9019V10.4359H16.8349V8.94113Z" fill="#219653" />
    <path d="M16.8349 11.3195H13.9019V12.8142H16.8349V11.3195Z" fill="#219653" />
    <path d="M16.8349 13.6978H13.9019V15.1926H16.8349V13.6978Z" fill="#219653" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.94975 6.38034L4.40605 6.29719L5.32135 8.817L6.40272 6.19295L7.85902 6.1098L6.09101 9.68754L7.85902 13.2746L6.31968 13.1703L5.27983 10.4365L4.23935 13.0661L2.8252 12.9414L4.46864 9.77317L2.94975 6.38034Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="clip0">
      <rect y="0.5" width="19" height="19" fill="white" />
    </clipPath>
  </defs>
</svg>
